if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
/* page product */
var btnConvertSizeCM = document.querySelectorAll(".btn-size-chart.cm,.ks-unit-toggle-label.cm");
var btnConvertSizeIN = document.querySelectorAll(".btn-size-chart.in,.ks-unit-toggle-label.inches");

btnConvertSizeCM.forEach(function (btn) {
  btn.addEventListener("click", function () {
    if (btn.classList.contains("is-active") || btn.classList.contains("active")) return;
    handleSizeChartCm();
  });
});
function getListSize(element) {
  const listSize = element.textContent.split("-");
  const size1 = parseFloat(listSize[0].replace("in", "").replace("cm", ""));
  const size2 = parseFloat(listSize[1].replace("in", "").replace("cm", ""));
  const oldValue = `${size1} - ${size2}`;
  return oldValue;
}
function handleSizeChartCm() {
  btnConvertSizeCM.forEach(function (btn) {
    btn.classList.add("is-active");
  });
  document.querySelectorAll(".data-size-chart,.ks-table-cell").forEach(function (element) {
    let oldValue = element.getAttribute("old-value");
    if(element.textContent.includes("in") || element.textContent.includes("cm") || element.textContent.includes('"')){
      if (!oldValue) {
        oldValue = parseFloat(
          element.textContent.replace("in", "").replace("cm", "")
        );
        element.setAttribute("old-value", oldValue);
      }
  
      element.textContent = `${(oldValue * 2.54).toFixed(2)} cm`;
    }
  });
  document.querySelectorAll(".data-size-chart-2").forEach(function (element) {
    let oldValue = element.getAttribute("old-value");
    if(element.textContent.includes("in") || element.textContent.includes("cm") || element.textContent.includes('"')){
      if (!oldValue && element.textContent) {
        oldValue = getListSize(element);
        element.setAttribute("old-value", oldValue);
      }
      const listSize = oldValue.split("-");
      element.textContent = `${(listSize[0] * 2.54).toFixed(1)} - ${(
        listSize[1] * 2.54
      ).toFixed(1)} cm`;
    }
  });

  btnConvertSizeIN.forEach(function (btn) {
    btn.classList.remove("is-active");
    btn.classList.remove("active");
  });
}

btnConvertSizeIN.forEach(function (btn) {
  btn.addEventListener("click", function () {
    if (btn.classList.contains("is-active") || btn.classList.contains("active")) return;
    handleSizeChartIn();
  });
});

function handleSizeChartIn() {
  btnConvertSizeIN.forEach(function (btn) {
    btn.classList.add("is-active");
  });
  document.querySelectorAll(".data-size-chart,.ks-table-cell").forEach(function (element) {
    let oldValue = element.getAttribute("old-value");
    if(element.textContent.includes("in") || element.textContent.includes("cm") || element.textContent.includes('"')){
      if (!oldValue) {
        oldValue = parseFloat(
          element.textContent.replace("in", "").replace("cm", "")
        );
        element.setAttribute("old-value", oldValue);
        element.textContent = `${(oldValue / 2.54).toFixed(2)}${element.matches('.ks-table-cell') ?'"':'in'}`;
      }
  
      element.textContent = `${oldValue}${element.matches('.ks-table-cell') ?'"':'in'}`;
    }
  });

  document.querySelectorAll(".data-size-chart-2").forEach(function (element) {
    let oldValue = element.getAttribute("old-value");
    if (!oldValue && element.textContent) {
      oldValue = getListSize(element);
      element.setAttribute("old-value", oldValue);
      element.textContent = `${(size1 / 2.54).toFixed(1)} in - ${(
        size2 / 2.54
      ).toFixed(1)} in`;
    }
    const listSize = oldValue.split("-");
    element.textContent = `${listSize[0]} - ${listSize[1]} in`;
  });

  btnConvertSizeCM.forEach(function (btn) {
    btn.classList.remove("is-active");
  });
}